import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { LoadingComponent } from './components/loading/loading.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseCardComponent } from '../../ui/base-card/base-card.component';
import { DndDirective } from '../../directives/dnd-directive';
import {
  NgbAccordionBody,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionItem,
  NgbCollapse,
  NgbDatepicker,
  NgbDropdown,
  NgbDropdownAnchor,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbPopover,
  NgbTooltipModule,
  NgbTypeahead,
} from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { NgxPopperjsModule } from 'ngx-popperjs';
import { ThrottleClickDirective } from '../../directives/throttle-click.directive';
import { ReactiveFormModule } from '@csspension/reactive-form';
import { LookAheadItemComponent } from './components/search-with-look-ahead/look-ahead-list/look-ahead-item/look-ahead-item.component';
import { LookAheadListComponent } from './components/search-with-look-ahead/look-ahead-list/look-ahead-list.component';
import { DarkBackButtonComponent } from './components/dark-back-button/dark-back-button.component';
import { CloseButtonComponent } from '../../ui/buttons/close-button/close-button.component';
import { LogoComponent } from './components/logo/logo.component';
import { CustomToastComponent } from './components/custom-toast/custom-toast.component';
import { BaseActionModalComponent } from './modals/base-action-modal/base-action-modal.component';
import { ReactiveButtonsModule } from '@csspension/reactive-buttons';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { TrustAsHtmlPipe } from './pipes/trust-as-html-pipe';
import { SlidingWindowComponent } from './components/sliding-window/sliding-window.component';
import { SlidingWindowHeaderComponent } from './components/sliding-window/sliding-window-header/sliding-window-header.component';
import { SlidingWindowFooterComponent } from './components/sliding-window/sliding-window-footer/sliding-window-footer.component';
import { PillComponent } from '../../ui/pills/pill/pill.component';
import { TableOverlayLoadingComponent } from './components/table-overlay-loading/table-overlay-loading.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { TabBarComponent } from '../../ui/tab-bar/tab-bar.component';
import { TabContentComponent } from '../../ui/tab-bar/tab-content/tab-content.component';
import { EulaModalComponent } from './modals/eula-modal/eula-modal.component';
import { AddRemoveRoleFormComponent } from './components/add-remove-role-form/add-remove-role-form.component';
import { ViewUserComponent } from './components/view-user/view-user.component';
import { ChangeUserEmailModalComponent } from './modals/change-user-email-modal/change-user-email-modal.component';
import { FakeCheckBoxComponent } from './components/fake-check-box/fake-check-box.component';
import { TableColumnSearchBarComponent } from './components/table-column-search-bar/table-column-search-bar.component';
import { StatusPillComponent } from '../../ui/pills/status-pill.component';
import { IsCurrentEmploymentPipe } from '../../pipes/is-current-employment.pipe';
import { CurrentEmployerPillComponent } from '../../ui/pills/current-employer-pill/current-employer-pill.component';
import { PendingSubmissionModalCardComponent } from './components/pending-submission-modal-card/pending-submission-modal-card.component';
import { UserProfileBadgeComponent } from './components/user-profile-badge/user-profile-badge.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DashboardHeaderComponent } from './components/dashboard-header/dashboard-header.component';
import { ReorderModalComponent } from './modals/reorder-modal/reorder-modal.component';
import { ReorderListComponent } from './components/reorder-list/reorder-list.component';
import { ReorderListItemComponent } from './components/reorder-list-item/reorder-list-item.component';
import { TableColumnDropDownBarComponent } from './components/table-column-drop-down-bar/table-column-drop-down-bar.component';
import { OdataTypeaheadSearchComponent } from './components/odata-typeahead-search/odata-typeahead-search.component';
import { SearchableModalComponent } from './modals/searchable-modal/searchable-modal.component';
import { SubmissionPermissionCheckboxTableComponent } from './components/submission-permission-checkbox-table/submission-permission-checkbox-table.component';
import { IndeterminateCheckboxComponent } from './components/indeterminate-checkbox/indeterminate-checkbox.component';
import { MaskSinNumberPipe } from './pipes/mask-sin-number.pipe';
import { DateValidDirective } from './directives/date-valid-directive.directive';
import { AlertComponent } from './components/alert/alert.component';
import { CardAlertComponent } from './components/alert/components/card-alert/card-alert.component';
import { BannerAlertComponent } from './components/alert/components/banner-alert/banner-alert.component';
import { IsCardTypeAlertPipe } from './components/alert/pipes/is-card-type-alert.pipe';
import { IsBannerTypeAlertPipe } from './components/alert/pipes/is-banner-type-alert.pipe';
import { StartEndDateValidatorDirective } from './directives/start-end-date-validator.directive';
import { NameChangeSubmissionFormComponent } from './components/name-change-submission-form/name-change-submission-form.component';
import { GoverningJurisdictionNamePipe } from './pipes/governing-jurisdiction-name.pipe';
import { AccountAssetSelectionJurisdictionRowComponent } from './components/account-asset-selection/account-asset-selection-jurisdiction-row/account-asset-selection-jurisdiction-row.component';
import { AccountAssetSelectionTypeRadioGroupComponent } from './components/account-asset-selection/account-asset-selection-type-radio-group/account-asset-selection-type-radio-group.component';
import { AccountAssetSelectionUnlockFundsModalComponent } from './components/account-asset-selection/account-asset-selection-unlock-funds-modal/account-asset-selection-unlock-funds-modal.component';
import { AddressChangeSubmissionFormComponent } from './components/address-change-submission-form/address-change-submission-form.component';
import { AddressSubmissionInProgressBannerComponent } from './components/address-submission-in-progress-banner/address-submission-in-progress-banner.component';
import { UpdateContactInfoSubmissionFormComponent } from './components/update-contact-info-submission-form/update-contact-info-submission-form.component';
import { HeaderContainerComponent } from '../../ui/headers/header-container/header-container.component';
import { EntryFirstCurrencySymbolPipe } from './pipes/entry-currency.pipe';
import { RouterLink } from '@angular/router';
import { LabeledListItemComponent } from './components/labeled-list-item/labeled-list-item.component';
import { HistoryItemComponent } from './components/history-item/history-item.component';
import { DateStringWithAtPipe } from './components/history-item/history-item-date-string.pipe';
import { EntryCodeNamePipe } from './pipes/entry-code-name.pipe';
import { PersonalInfoSubmissionFormComponent } from './components/personal-info-submission-form/personal-info-submission-form.component';
import { BreadcrumbHeaderComponent } from '../../ui/headers/breadcrumb-header/breadcrumb-header.component';
import { TableOverlayBufferComponent } from './components/table-overlay-buffer/table-overlay-buffer.component';
import { LeadingZeroPipe } from './pipes/leading-zero.pipe';
import { DataLabelComponent } from './components/data-label/data-label.component';
import { StepperComponent } from '../../ui/stepper/stepper.component';
import { FileUploaderTextComponent } from '../../ui/form-components/file-uploader/file-uploader-text/file-uploader-text.component';
import { SimplePillComponent } from './components/simple-pill/simple-pill.component';
import { IncludesPipe } from './pipes/includes.pipe';
import { SetHasPipe } from './pipes/set-has.pipe';
import { MapGetPipe } from './pipes/map-get.pipe';
import { CurrencySpacePipe } from './pipes/currency-space.pipe';
import { StickyFooterComponent } from '../../ui/sticky-footer/sticky-footer.component';
import { MemberSearchComponent } from './components/member-search/member-search.component';
import { MemberSearchInputComponent } from './components/member-search-input/member-search-input.component';
import { PortalTypePipe } from './pipes/portal-type.pipe';
import { VersionNumberExistsValidatorDirective } from './directives/version-number-exists-validator.directive';
import { FormattedDateStringInCSTPipe } from './pipes/formatted-date-string-in-cst.pipe';
import { ReleaseNoteModalComponent } from './components/release-note-modal/release-note-modal.component';
import { SlidingWindowCommentsComponent } from './components/sliding-window-comments/sliding-window-comments.component';
import { LoadingShimmerModule } from 'loading-shimmer';
import { DesignatedUnitVersionUniqueStartDateValidatorDirective } from './directives/designated-unit-version-unique-start-date-validator.directive';
import { MinDesignatedUnitPercentageValidatorDirective } from './directives/min-designated-unit-percentage-validator.directive';
import { MatchedDesignatedUnitRangeValidatorDirective } from './directives/matched-designated-unit-range-validator.directive';
import { UnmatchedDesignatedUnitRangeValidatorDirective } from './directives/unmatched-designated-unit-range-validator.directive';
import { DesignatedUnitUniqueNameValidatorDirective } from './directives/designated-unit-unique-name-validator.directive';
import { EmployerSearchInputComponent } from './components/employer-search-input/employer-search-input.component';
import { DesignatedUnitSearchInputComponent } from './components/designated-unit-search-input/designated-unit-search-input.component';
import { StaticInfoContainerComponent } from './components/static-info-container/static-info-container.component';
import { HumanReadablePipe } from './pipes/human-readable.pipe';
import { ValidCreateRemittanceFileDirective } from './directives/valid-create-remittance-file.directive';
import { DataLabelPillComponent } from './components/data-label-pill/data-label-pill.component';
import { UniqueSinValidatorDirective } from './directives/unique-sin-validator.directive';
import { LabeledListSinItemComponent } from './components/labeled-list-sin-item/labeled-list-sin-item.component';
import { BlackBackButtonComponent } from '../../ui/buttons/black-back-button/black-back-button.component';
import { CommentsFormComponent } from './components/comments/comments-form.component';
import { SlidingWindowCommentsAndHistoryComponent } from './components/sliding-window-comments-and-history/sliding-window-comments-and-history.component';
import { SlidingWindowHistoryTabComponent } from './components/sliding-window-comments-and-history/sliding-window-history-tab/sliding-window-history-tab.component';
import { SlidingWindowCommentsTabComponent } from './components/sliding-window-comments-and-history/sliding-window-comments-tab/sliding-window-comments-tab.component';
import { SystemBannerAlertComponent } from './components/alert/components/system-banner-alert/system-banner-alert.component';
import { SubmissionContainerComponent } from './components/submission-container/submission-container.component';
import { DonutChartComponent } from './components/donut-chart/donut-chart.component';
import { DonutChartLegendComponent } from './components/donut-chart/donut-chart-legend/donut-chart-legend.component';
import { DonutChartWithLegendComponent } from './components/donut-chart/donut-chart-with-legend/donut-chart-with-legend.component';
import { MobileNumericInputComponent } from './components/mobile-numeric-input/mobile-numeric-input.component';
import { RepeatDirective } from '../../directives/repeat.directive';
import { CheckboxInputComponent } from '../../ui/form-components/checkbox-input/checkbox-input.component';
import { SwitchInputComponent } from '../../ui/form-components/switch-input/switch-input.component';
import { FormOptionLabelComponent } from '../../ui/form-components/form-option-label/form-option-label.component';
import { CommentListComponent } from './components/comments/comment-list/comment-list.component';
import { InViewDirective } from './directives/in-view.directive';
import { CurrencyInputComponent } from '../../ui/form-components/currency-input/currency-input.component';
import { RecurringCurrencyInputComponent } from '../../ui/form-components/recurring-currency-input/recurring-currency-input.component';
import { MaskitoDirective } from '@maskito/angular';
import { InvestmentInstructionsCardComponent } from './components/investment-instructions-card/investment-instructions-card.component';
import { InvestmentInstructionFundColourPipe } from './components/investment-instructions-card/investment-instruction-fund-colour.pipe';
import { PercentageInputComponent } from '../../ui/form-components/percentage-input/percentage-input.component';
import { ActionCardComponent } from './components/action-card/action-card.component';
import { AffectedAccountsCardComponent } from './components/affected-accounts-card/affected-accounts-card.component';
import { JoinPipe } from './pipes/join.pipe';
import { ButtonToggleComponent } from './components/button-toggle/button-toggle.component';
import { TabToggleComponent } from './components/tab-toggle/tab-toggle.component';
import { DesignatedUnitsTableCardComponent } from './components/tables/designated-units-table-card/designated-units-table-card.component';
import { DesignatedUnitsTableCardTableHeaderComponent } from './components/tables/designated-units-table-card/designated-units-table-header/designated-units-table-header.component';
import { DesignatedUnitsTableCardTableRowComponent } from './components/tables/designated-units-table-card/designated-units-table-row/designated-units-table-row.component';
import { CreateDesignatedUnitModalComponent } from './components/tables/designated-units-table-card/create-designated-unit-modal/create-designated-unit-modal.component';
import { CreateDesignatedUnitGeneralDetailsStepComponent } from './components/tables/designated-units-table-card/create-designated-unit-modal/step-components/create-designated-unit-general-details-step/create-designated-unit-general-details-step.component';
import { CreateDesignatedUnitContributionDetailsStepComponent } from './components/tables/designated-units-table-card/create-designated-unit-modal/step-components/create-designated-unit-contribution-details-step/create-designated-unit-contribution-details-step.component';
import { CreateDesignatedUnitGeneralDetailsAboutSectionComponent } from './components/form-grids/designated-unit/designated-unit-about-section/designated-unit-about-section.component';
import { CreateDesignatedUnitGeneralDetailsEffectivePeriodSectionComponent } from './components/form-grids/designated-unit/designated-unit-effective-period-section/designated-unit-effective-period-section.component';
import { CreateDesignatedUnitRequiredContributionsFormComponent } from './components/form-grids/designated-unit/designated-unit-required-contributions-form/designated-unit-required-contributions-form.component';
import { CreateDesignatedUnitEmployeeParticipationFormComponent } from './components/form-grids/designated-unit/designated-unit-employee-participation-form/designated-unit-employee-participation-form.component';
import { ChangeMemberEmailModalComponent } from './modals/change-member-email-modal/change-member-email-modal.component';
import { RadioButtonInputComponent } from '../../ui/form-components/radio-button-input/radio-button-input.component';
import { PrimaryCreateSubmissionButtonComponent } from './components/primary-create-submission-button/primary-create-submission-button.component';
import { ChangeInvestmentInstructionsSubmissionFormComponent } from './components/change-investment-instructions-submission-form/change-investment-instructions-submission-form.component';
import { AccountInvestmentInstructionsCardComponent } from './components/account-investment-instructions-card/account-investment-instructions-card.component';
import { FileUploadInputComponent } from '../../ui/form-components/file-uploader/file-upload-input/file-upload-input.component';
import { FileListItemComponent } from '../../ui/file-list-item/file-list-item.component';
import { AttachmentLinkPipe } from '../../pipes/attachment-link.pipe';
import { LocalDateTimePipe } from '../../pipes/local-date-time.pipe';
import { SubmissionPermissionTooltipPipe } from '../../pipes/submission-permission-tooltip.pipe';
import { FileUploadFieldComponent } from '../../ui/form-components/file-uploader/file-upload-field/file-upload-field.component';
import { AffectedAccountComponent } from './components/affected-account/affected-account.component';
import { InternalPortalAffectedAccountsCardComponent } from './components/internal-portal-affected-accounts-card/internal-portal-affected-accounts-card.component';
import { SearchInputComponent } from '../../ui/search-input/search-input.component';
import { NumericInputComponent } from '../../ui/form-components/numeric-input/numeric-input.component';
import { NumericStringInputComponent } from '../../ui/form-components/numeric-string-input/numeric-string-input.component';
import { PillPickerInputComponent } from '../../ui/form-components/pill-picker-input/pill-picker-input.component';
import { PreviousInstructionsSubmissionVisualizationComponent } from './components/investment-instructions-visualization/previous-instructions-submission-visualization/previous-instructions-submission-visualization.component';
import { CurrentInstructionsVisualizationComponent } from './components/investment-instructions-visualization/current-instructions-visualization/current-instructions-visualization.component';
import { FutureInstructionsVisualizationComponent } from './components/investment-instructions-visualization/future-instructions-visualization/future-instructions-visualization.component';
import { FundAllocationVisualizationComponent } from './components/fund-allocation-visualization/fund-allocation-visualization.component';
import { CommentComponent } from '../../ui/comment/comment.component';
import { InvestmentInstructionSubmissionAffectedAccountsCardComponent } from './components/investment-instruction-submission-affected-accounts-card/investment-instruction-submission-affected-accounts-card.component';
import { InvestmentInstructionSubmissionAffectedAccountListItemComponent } from './components/investment-instruction-submission-affected-account-list-item/investment-instruction-submission-affected-account-list-item.component';
import { InvestmentInstructionSubmissionChangesCardComponent } from './components/investment-instruction-submission-changes-card/investment-instruction-submission-changes-card.component';
import { InvestmentInstructionSubmissionInstructionChangesComponent } from './components/investment-instruction-submission-instruction-changes/investment-instruction-submission-instruction-changes.component';
import { InvestmentInstructionSubmissionAllocationChangesComponent } from './components/investment-instruction-submission-allocation-changes/investment-instruction-submission-allocation-changes.component';
import { FilterSectionHeaderComponent } from './components/filter-section-header/filter-section-header.component';
import { FixedDecimalPipe } from './pipes/fixed-decimal.pipe';
import { PhoneCountryCodeComponent } from '../../ui/form-components/phone-country-code/phone-country-code.component';
import { PhoneCountryCodeNumberInputComponent } from '../../ui/form-components/phone-country-code/phone-number-input/phone-country-code-number-input.component';
import { DropdownInputComponent } from '../../ui/form-components/dropdown-input/dropdown-input.component';
import { MpProfileStaticInfoContainerComponent } from './components/mp-profile-static-info-container/mp-profile-static-info-container.component';
import { SINInputComponent } from '../../ui/form-components/sin-input/sin-input/sin-input.component';
import { EmailInputComponent } from '../../ui/form-components/email-input/email-input/email-input.component';
import { ButtonComponent } from '../../ui/buttons/button/button.component';
import { PhoneCountryCodeDropdownInputComponent } from '../../ui/form-components/phone-country-code/country-code-dropdown-input/phone-country-code-dropdown-input.component';
import { TextareaInputComponent } from '../../ui/form-components/textarea-input/textarea-input.component';
import { ExistingSubmissionBannerComponent } from './components/existing-submission-banner/existing-submission-banner.component';
import { DropdownButtonComponent } from './components/dropdown-button/dropdown-button.component';
import { DatepickerInputComponent } from '../../ui/form-components/datepicker-input/datepicker-input.component';
import { DatepickerInputCalendarComponent } from '../../ui/form-components/datepicker-input/datepicker-input-calendar/datepicker-input-calendar.component';
import { MpProfileEmployerHistoryStaticInfoContainerComponent } from './components/mp-profile-employer-history-static-info-container/mp-profile-employer-history-static-info-container.component';
import { SpouseInformationRadioButtonsComponent } from './components/spouse-information-radio-buttons/spouse-information-radio-buttons.component';
import { SpousePersonalInformationFormComponent } from './components/spouse-personal-information-form/spouse-personal-information-form.component';
import { TextInputComponent } from '../../ui/form-components/text-input/text-input.component';
import { SpouseContactDetailsFormComponent } from './components/spouse-contact-details-form/spouse-contact-details-form.component';
import { RelationshipStatusEffectiveDateLabelPipe } from '../../pipes/relationship-status-effective-date-label.pipe';
import { RelationshipStatusFileUploadLabelPipe } from './pipes/relationship-status-file-upload-label.pipe';
import { FormErrorComponent } from '../../ui/form-components/form-error/form-error.component';
import { BaseLoadingButtonModalComponent } from '../../ui/modals/base-loading-button-modal/base-loading-button-modal.component';
import { RelationshipStatusFileUploadCopyPipe } from './pipes/relationship-status-file-upload-copy.pipe';
import { RelationshipStatusSubmissionDetailGroupingComponent } from './components/relationship-status-submission-detail-grouping/relationship-status-submission-detail-grouping.component';
import { SubmissionDetailsChangesComponent } from './components/submission-details-changes/submission-details-changes.component';
import { SubmissionSubmittedFileListComponent } from './components/submission-submitted-file-list/submission-submitted-file-list.component';
import { SubmissionAdditionalFileListComponent } from './components/submission-additional-file-list/submission-additional-file-list.component';
import { EllipsisPipe } from '../../pipes/ellipsis.pipe';
import { DateInputComponent } from '../../ui/form-components/date-input/date-input.component';
import { TypeaheadDropdownInputComponent } from '../../ui/form-components/typeahead-dropdown-input/typeahead-dropdown-input.component';
import { TypeaheadSearchInputComponent } from '../../ui/form-components/typeahead-search-input/typeahead-search-input.component';
import { ReviewEntryComponent } from '../../ui/review-components/review-entry/review-entry.component';
import { RelationshipEffectiveDateReviewEntryComponent } from '../../ui/review-components/relationship-effective-date-review-entry/relationship-effective-date-review-entry.component';
import { SinReviewEntryComponent } from '../../ui/review-components/sin-review-entry/sin-review-entry.component';
import { DefinedContributionAccountsAccordionComponent } from './components/defined-contribution-accounts-accordion/defined-contribution-accounts-accordion.component';
import { AccountTypeNamePipe } from './pipes/account-type-name.pipe';
import { AccountDisplayNamePipe } from './pipes/account-display-name.pipe';
import { SubmissionAffectedAccountDisplayNamePipe } from './pipes/submission-affected-account-display-name.pipe';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { SubmissionDetailsFieldChangesComponent } from './components/submission-details-field-changes/submission-details-field-changes.component';
import { BeneficiaryDetailsIndividualChangesComponent } from '../../features/beneficiaries/components/beneficiary-details-individual-changes/beneficiary-details-individual-changes.component';
import { BeneficiaryDetailsOrganizationChangesComponent } from '../../features/beneficiaries/components/beneficiary-details-organization-changes/beneficiary-details-organization-changes.component';
import { BeneficiaryDetailsEstateChangesComponent } from '../../features/beneficiaries/components/beneficiary-details-estate-changes/beneficiary-details-estate-changes.component';
import { AccountTypeSelectionFormComponent } from './components/account-type-selection-form/account-type-selection-form.component';
import { MemberPersonalInformationOnboardingModalComponent } from './components/member-personal-information-onboarding-modal/member-personal-information-onboarding-modal.component';
import { MemberOnboardingModalPersonalInformationFormComponent } from './components/member-personal-information-onboarding-modal/member-onboarding-modal-personal-information-form/member-onboarding-modal-personal-information-form.component';
import { MemberOnboardingModalContactInformationFormComponent } from './components/member-personal-information-onboarding-modal/member-onboarding-modal-contact-information-form/member-onboarding-modal-contact-information-form.component';
import { TextButtonComponent } from '../../ui/buttons/text-button/text-button.component';
import { MaskedTextInputComponent } from '../../ui/form-components/masked-text-input/masked-text-input.component';
import { FiduciaryTypeNamePipe } from './pipes/fiduciary-type-name.pipe';
import { FormattedPhoneNumberPipe } from './pipes/formatted-phone-number.pipe';
import { DateIsInThePastPipe } from './pipes/date-is-in-the-past.pipe';
import { MemberVerificationDetailsComponent } from './components/member-verification-card/member-verification-details.component';
import { MemberVerificationLabelItemComponent } from './components/member-verification-card/member-verification-label-item/member-verification-label-item.component';
import { NoInvestedFundsBannerComponent } from './components/no-invested-funds-banner/no-invested-funds-banner.component';
import { EmploymentDetailsFormGridComponent } from './components/form-grids/employment-details-form-grid/employment-details-form-grid.component';
import { InternationalAddressFormGridComponent } from '../../ui/form-grids/international-address-form-grid/international-address-form-grid.component';
import { HeadOfficeAddressFormGridComponent } from './components/form-grids/head-office-address-form-grid/head-office-address-form-grid.component';
import { MailingAddressFormGridComponent } from './components/form-grids/mailing-address-form-grid/mailing-address-form-grid.component';
import { TableHeaderDateInputComponent } from '../../ui/tables/table-column-inputs/table-header-date-input/table-header-date-input.component';
import { TableHeaderNumberInputComponent } from '../../ui/tables/table-column-inputs/table-header-number-input/table-header-number-input.component';
import { TableHeaderDropdownInputComponent } from '../../ui/tables/table-column-inputs/table-header-dropdown-input/table-header-dropdown-input.component';
import { TableHeaderTextInputComponent } from '../../ui/tables/table-column-inputs/table-header-text-input/table-header-text-input.component';
import { TableColumnHeaderComponent } from '../../ui/tables/table-column-header/table-column-header.component';
import { ResizableModule } from '@csspension/reactive-table';
import { TablePaginatorComponent } from '../../ui/tables/table-paginator/table-paginator.component';
import { TableResultsTextComponent } from '../../ui/tables/table-results-text/table-results-text.component';
import { TableFooterComponent } from '../../ui/tables/table-footer/table-footer.component';
import { TableFilterPillsComponent } from '../../ui/tables/table-filter-pills/table-filter-pills.component';
import { TableEmptyStateComponent } from '../../ui/tables/table-empty-state/table-empty-state.component';
import { SearchPillInputComponent } from '../../ui/form-components/search-pill-input/search-pill-input.component';
import { BatchAddMembersFileRequirementsComponent } from './components/batch-add-members-file-requirements/batch-add-members-file-requirements.component';
import { BatchAddMembersFileUploadComponent } from './components/batch-add-members-file-upload/batch-add-members-file-upload.component';
import { BatchAddMembersFilePreviewModalComponent } from './components/batch-add-members-file-preview-modal/batch-add-members-file-preview-modal.component';
import { BatchAddMemberFilePreviewTableComponent } from './components/batch-add-members-file-preview-modal/batch-add-member-file-preview-table/batch-add-member-file-preview-table.component';
import { SinDisplayFieldComponent } from './components/sin-display-field/sin-display-field.component';
import { BatchAddMembersInformationTableCardComponent } from './components/batch-add-members-information-table-card/batch-add-members-information-table-card.component';
import { MemberTableDateInputComponent } from './components/member-table-inputs/member-table-date-input/member-table-date-input.component';
import { MemberTableEmailInputComponent } from './components/member-table-inputs/member-table-email-input/member-table-email-input.component';
import { MemberTableSinInputComponent } from './components/member-table-inputs/member-table-sin-input/member-table-sin-input.component';
import { MemberTableTextInputComponent } from './components/member-table-inputs/member-table-text-input/member-table-text-input';
import { MemberTableTypeaheadDropdownComponent } from './components/member-table-inputs/member-table-typeahead-dropdown/member-table-typeahead-dropdown.component';
import { FiduciarySubmissionSubmittedFileListComponent } from './components/fiduciary-submission-submitted-file-list/fiduciary-submission-submitted-file-list.component';
import { ChipComponent } from './components/chip/chip.component';
import { EmployerRecordPrimaryContactAccordionComponent } from './components/employer-record-accordions/employer-record-primary-contact-accordion/employer-record-primary-contact-accordion.component';
import { EmployerRecordAdditionalContactAccordionComponent } from './components/employer-record-accordions/employer-record-additional-contact-accordion/employer-record-additional-contact-accordion.component';
import { TableCellShimmerComponent } from '../../ui/tables/table-cell-shimmer/table-cell-shimmer.component';
import { EmployerRecordContactRemoveModalComponent } from './components/employer-record-accordions/employer-record-contact-remove-modal/employer-record-contact-remove-modal.component';
import { EmployerRecordAddAdditionalContactModalComponent } from './components/employer-record-add-additional-contact-modal/employer-record-add-additional-contact-modal.component';
import { EmployerRecordAddPrimaryContactModalComponent } from './components/employer-record-add-primary-contact-modal/employer-record-add-primary-contact-modal.component';
import { EmploymentStatusPillPipe } from './pipes/employment-status-pill.pipe';
import { MemberActiveStatusPillPipe } from './pipes/member-active-status-pill.pipe';
import { RemittanceStatusPillPipe } from './pipes/remittance-status-pill.pipe';
import { RemittancePaymentStatusPillPipe } from './pipes/remittance-payment-status-pill.pipe';
import { EmployerContactSubmissionChangeCardComponent } from './components/employer-contact-submission-change-card/employer-contact-submission-change-card.component';
import { EmployerContactSubmissionDetailsFieldChangeComponent } from './components/employer-contact-submission-details-field-change/employer-contact-submission-details-field-change.component';
import { EmployerRecordContactsSectionComponent } from './components/employer-record-contacts-section/employer-record-contacts-section.component';
import { EmployerContactCardComponent } from './components/employer-contact-card/employer-contact-card.component';
import { SubmissionStatusLabelPipe } from './pipes/submission-status-label.pipe';
import { SubmissionStatusDateStringPipe } from './pipes/submission-status-date-string-pipe';
import { SubmissionStatusDatePipe } from './pipes/submission-status-date.pipe';
import { EmployerRecordPlanOverviewComponent } from './components/employer-record-plan-overview/employer-record-plan-overview.component';
import { AccordionRemittanceItemComponent } from './components/remittance-item/accordion-remittance-item/accordion-remittance-item.component';
import { RemittanceItemDetailsComponent } from './components/remittance-item/remittance-item-details/remittance-item-details.component';
import { RemittanceItemHeaderComponent } from './components/remittance-item/remittance-item-header/remittance-item-header.component';
import { RemittanceTransactionPreviewCardComponent } from './components/remittance-item/remittance-transaction-preview-card/remittance-transaction-preview-card.component';
import { EmployerLogoHeaderComponent } from './components/employer-logo-header/employer-logo-header.component';
import { ConfirmRelationshipStatusGridComponent } from './components/confirm-relationship-status-grid/confirm-relationship-status-grid.component';
import { AgePipe } from './pipes/age.pipe';
import { VbWithdrawalInstructionsCardComponent } from './components/create-variable-benefit-submission-components/vb-withdrawal-instructions-card/vb-withdrawal-instructions-card.component';
import { VbWithdrawalPercentFieldComponent } from './components/create-variable-benefit-submission-components/vb-withdrawal-instructions-card/vb-withdrawal-percent-field/vb-withdrawal-percent-field.component';
import { VbWithdrawalPercentageInputLabelComponent } from './components/create-variable-benefit-submission-components/vb-withdrawal-instructions-card/vb-withdrawal-percent-field/vb-withdrawal-percentage-input-label/vb-withdrawal-percentage-input-label.component';
import { FundTypeByIdPipe } from './pipes/fund-type-by-id.pipe';
import { BankAccountAccordionRadioCardComponent } from './components/vb-config/vb-bank-account-accordion-radio-card/bank-account-accordion-radio-card.component';
import { PaylineAccountAccordionRadioCardComponent } from './components/payline-account-accordion-radio-card/payline-account-accordion-radio-card.component';
import { WrittenChequeCardComponent } from './components/written-cheque-card/written-cheque-card.component';
import { VbConfigAccountDetailsReviewCardComponent } from './components/vb-config/create-vb-review-components/vb-config-account-details-review-card/vb-config-account-details-review-card.component';
import { VbConfigAssetsUsedReviewCardComponent } from './components/vb-config/create-vb-review-components/vb-config-assets-used-review-card/vb-config-assets-used-review-card.component';
import { VbConfigMinAgeReviewCardComponent } from './components/vb-config/create-vb-review-components/vb-config-min-age-review-card/vb-config-min-age-review-card.component';
import { VbConfigRecurringPaymentsReviewCardComponent } from './components/vb-config/create-vb-review-components/vb-config-recurring-payments-review-card/vb-config-recurring-payments-review-card.component';
import { VbConfigLumpSumReviewCardComponent } from './components/vb-config/create-vb-review-components/vb-config-lump-sum-review-card/vb-config-lump-sum-review-card.component';
import { VbConfigWithdrawalInstructionsReviewCardComponent } from './components/vb-config/create-vb-review-components/vb-config-withdrawal-instructions-review-card/vb-config-withdrawal-instructions-review-card.component';
import { VbConfigDepositInstructionsReviewCardComponent } from './components/vb-config/create-vb-review-components/vb-config-deposit-instructions-review-card/vb-config-deposit-instructions-review-card.component';
import { UpdateVbConfigAccountDetailsReviewCardComponent } from './components/vb-config/update-vb-review-components/update-vb-config-account-details-review-card/update-vb-config-account-details-review-card.component';
import { UpdateVbConfigAssetsUsedReviewCardComponent } from './components/vb-config/update-vb-review-components/update-vb-config-assets-used-review-card/update-vb-config-assets-used-review-card.component';
import { UpdateVbConfigMinAgeReviewCardComponent } from './components/vb-config/update-vb-review-components/update-vb-config-min-age-review-card/update-vb-config-min-age-review-card.component';
import { UpdateVbPaymentsMinAgeReviewCardComponent } from './components/vb-config/update-vb-review-components/update-vb-payments-min-age-review-card/update-vb-payments-min-age-review-card.component';
import { UpdateVbPaymentsDepositInstructionsReviewCardComponent } from './components/vb-config/update-vb-review-components/update-vb-payments-deposit-instructions-review-card/update-vb-payments-deposit-instructions-review-card.component';
import { UpdateVbPaymentsWithdrawalInstructionsReviewCardComponent } from './components/vb-config/update-vb-review-components/update-vb-payments-withdrawal-instructions-review-card/update-vb-payments-withdrawal-instructions-review-card.component';
import { SpousalWaiverUploadCardComponent } from './components/spousal-waiver-upload-card/spousal-waiver-upload-card.component';
import { AccountFileUploadComponent } from './components/account-file-upload/account-file-upload.component';
import { InvestmentInstructionAccountTypeContainerComponent } from './components/change-investment-instructions-submission-form/investment-instruction-account-type-container/investment-instruction-account-type-container.component';
import { VbAccountSummaryComponent } from './components/vb-account-accordion-item/vb-account-summary.component';
import { AccountStatusPillPipe } from './pipes/account-status-pill.pipe';
import { PasswordInputComponent } from '../../ui/form-components/password-input/password-input.component';
import { IsExhaustedAccountPipe } from './pipes/is-exhausted-account.pipe';
import { VbConfigSubmissionDetailsSpousalWaiverCardComponent } from './components/vb-config/vb-config-submission-details-spousal-waiver-card/vb-config-submission-details-spousal-waiver-card.component';
import { SubmissionDetailsSpousalWaiverCardComponent } from './components/submission-details-spousal-waiver-card/submission-details-spousal-waiver-card.component';
import { UpdateVbConfigRecurringPaymentsReviewCardComponent } from './components/vb-config/update-vb-review-components/update-vb-config-recurring-payments-review-card/update-vb-config-recurring-payments-review-card.component';
import { UpdateVbConfigRecurringPaymentReviewCardComponent } from './components/vb-config/update-vb-review-components/update-vb-config-recurring-payments-review-card/update-vb-config-recurring-payment-review-card/update-vb-config-recurring-payment-review-card.component';
import { UpdateVbConfigLumpSumReviewCardComponent } from './components/vb-config/update-vb-review-components/update-vb-config-lump-sum-review-card/update-vb-config-lump-sum-review-card.component';
import { VbPaymentChangeAccordionComponent } from './components/vb-payment-change/vb-payment-change-accordion/vb-payment-change-accordion.component';
import { VbPaymentsYearToDatePaymentsComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payments-year-to-date-payments/vb-payments-year-to-date-payments.component';
import { VbPaymentsAnnualMinimumComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payments-annual-minimum/vb-payments-annual-minimum.component';
import { VbPaymentsNextPaymentByComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payments-next-payment-by/vb-payments-next-payment-by.component';
import { VbPaymentsAnnualTotalComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payments-annual-total/vb-payments-annual-total.component';
import { VbPaymentChangeAgeForMinimumCalculationComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payment-change-age-for-minimum-calculation/vb-payment-change-age-for-minimum-calculation.component';
import { VbPaymentChangeAgeForMinimumCalculationJurisdictionComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payment-change-age-for-minimum-calculation/vb-payment-change-age-for-minimum-calculation-jurisdiction/vb-payment-change-age-for-minimum-calculation-jurisdiction.component';
import { VbPaymentChangeRecurringPaymentsComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payment-change-recurring-payments/vb-payment-change-recurring-payments.component';
import { VbPaymentChangeRecurringPaymentInstructionCardComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payment-change-recurring-payments/vb-payment-change-recurring-payment-instruction-card/vb-payment-change-recurring-payment-instruction-card.component';
import { VbPaymentChangeWithdrawalInstructionsComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payment-change-withdrawal-instructions/vb-payment-change-withdrawal-instructions.component';
import { VbPaymentChangeUpcomingLumpSumPaymentsComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payment-change-upcoming-lump-sum-payments/vb-payment-change-upcoming-lump-sum-payments.component';
import { VbPaymentChangeDepositInstructionsComponent } from './components/vb-payment-change/vb-payment-change-details/vb-payment-change-deposit-instructions/vb-payment-change-deposit-instructions.component';
import { VbPaymentChangeUpcomingPaymentsModalComponent } from './components/vb-payment-change/modals/vb-payment-change-upcoming-payments-modal/vb-payment-change-upcoming-payments-modal.component';
import { VariableBenefitAgeForMinimumCalculationNamePipe } from './pipes/variable-benefit-age-for-minimum-calculation-name.pipe';
import { CompactHeaderContainerComponent } from './components/compact-header-container/compact-header-container.component';
import { VbRecurringPaymentsFrequencyFormGridComponent } from './components/variable-benefit-accounts/components/vb-recurring-payments-frequency-form-grid/vb-recurring-payments-frequency-form-grid.component';
import { VbJurisdictionRecurringPaymentCardComponent } from './components/variable-benefit-accounts/components/vb-jurisdiction-recurring-payment-card/vb-jurisdiction-recurring-payment-card.component';
import { VbJurisdictionLumpSumPaymentCardComponent } from './components/variable-benefit-accounts/components/vb-jurisdiction-lump-sum-payment-card/vb-jurisdiction-lump-sum-payment-card.component';
import { VbTargetPaymentComponent } from './components/variable-benefit-accounts/components/vb-target-payment/vb-target-payment.component';
import { VariableBenefitConfigurationReviewAccountValuesModalComponent } from './components/variable-benefit-accounts/components/variable-benefit-configuration-review-account-values-modal/variable-benefit-configuration-review-account-values-modal.component';
import { VariableBenefitConfigurationReviewAnnualMinimumModalComponent } from './components/variable-benefit-accounts/components/variable-benefit-configuration-review-annual-minimum-modal/variable-benefit-configuration-review-annual-minimum-modal.component';
import { VbCurrentRecurringPaymentsCardComponent } from './components/variable-benefit-accounts/components/vb-current-recurring-payments-card/vb-current-recurring-payments-card.component';
import { VariableBenefitPaymentChangeWarningBannerComponent } from './components/vb-payment-change/banners/variable-benefit-payment-change-warning-banner/variable-benefit-payment-change-warning-banner.component';
import { IpBeneficiarySubmissionSpousalWaiverComponent } from './components/ip-beneficiary-submission-spousal-waiver/ip-beneficiary-submission-spousal-waiver.component';
import { MpBeneficiarySubmissionSpousalWaiverComponent } from './components/mp-beneficiary-submission-spousal-waiver/mp-beneficiary-submission-spousal-waiver.component';
import { SpousalWaiverTypeLabelPipe } from './pipes/spousal-waiver-type-label.pipe';
import { MonthlyPensionAccountContainerComponent } from './components/monthly-pension-account-container/monthly-pension-account-container.component';
import { IpAccountStatusMenuComponent } from '../../features/change-account-status/ip-account-status-menu/ip-account-status-menu.component';

/*
 * ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' })
 * see https://github.com/angular/angular/issues/48350
 */
@NgModule({
  providers: [],
  declarations: [
    DarkBackButtonComponent,
    LogoComponent,
    CustomToastComponent,
    IconButtonComponent,
    TrustAsHtmlPipe,
    TableOverlayLoadingComponent,
    PageHeaderComponent,
    EulaModalComponent,
    AddRemoveRoleFormComponent,
    ViewUserComponent,
    StaticInfoContainerComponent,
    ChangeUserEmailModalComponent,
    TableColumnSearchBarComponent,
    PendingSubmissionModalCardComponent,
    DashboardHeaderComponent,
    ReorderModalComponent,
    ReorderListComponent,
    ReorderListItemComponent,
    DatePickerComponent,
    TableColumnDropDownBarComponent,
    SearchableModalComponent,
    SubmissionPermissionCheckboxTableComponent,
    IndeterminateCheckboxComponent,
    DateValidDirective,
    AlertComponent,
    CardAlertComponent,
    IsCardTypeAlertPipe,
    IsBannerTypeAlertPipe,
    StartEndDateValidatorDirective,
    NameChangeSubmissionFormComponent,
    AddressChangeSubmissionFormComponent,
    AddressSubmissionInProgressBannerComponent,
    UpdateContactInfoSubmissionFormComponent,
    VersionNumberExistsValidatorDirective,
    LabeledListItemComponent,
    HistoryItemComponent,
    DateStringWithAtPipe,
    EntryCodeNamePipe,
    PersonalInfoSubmissionFormComponent,
    TableOverlayBufferComponent,
    SimplePillComponent,
    IncludesPipe,
    MapGetPipe,
    PortalTypePipe,
    ReleaseNoteModalComponent,
    SlidingWindowCommentsAndHistoryComponent,
    SlidingWindowCommentsTabComponent,
    SlidingWindowHistoryTabComponent,
    DesignatedUnitVersionUniqueStartDateValidatorDirective,
    MinDesignatedUnitPercentageValidatorDirective,
    MatchedDesignatedUnitRangeValidatorDirective,
    UnmatchedDesignatedUnitRangeValidatorDirective,
    DesignatedUnitUniqueNameValidatorDirective,
    EmployerSearchInputComponent,
    DesignatedUnitSearchInputComponent,
    HumanReadablePipe,
    ValidCreateRemittanceFileDirective,
    DataLabelPillComponent,
    UniqueSinValidatorDirective,
    LabeledListSinItemComponent,
    DonutChartComponent,
    DonutChartLegendComponent,
    DonutChartWithLegendComponent,
    MobileNumericInputComponent,
    ActionCardComponent,
    InvestmentInstructionsCardComponent,
    InvestmentInstructionFundColourPipe,
    AffectedAccountsCardComponent,
    JoinPipe,
    TabToggleComponent,
    DesignatedUnitsTableCardComponent,
    DesignatedUnitsTableCardTableHeaderComponent,
    DesignatedUnitsTableCardTableRowComponent,
    CreateDesignatedUnitModalComponent,
    CreateDesignatedUnitGeneralDetailsStepComponent,
    CreateDesignatedUnitContributionDetailsStepComponent,
    CreateDesignatedUnitGeneralDetailsAboutSectionComponent,
    CreateDesignatedUnitGeneralDetailsEffectivePeriodSectionComponent,
    CreateDesignatedUnitRequiredContributionsFormComponent,
    CreateDesignatedUnitEmployeeParticipationFormComponent,
    ChangeMemberEmailModalComponent,
    ChangeInvestmentInstructionsSubmissionFormComponent,
    AccountInvestmentInstructionsCardComponent,
    AffectedAccountComponent,
    InternalPortalAffectedAccountsCardComponent,
    PrimaryCreateSubmissionButtonComponent,
    PreviousInstructionsSubmissionVisualizationComponent,
    CurrentInstructionsVisualizationComponent,
    FutureInstructionsVisualizationComponent,
    FundAllocationVisualizationComponent,
    InvestmentInstructionSubmissionAffectedAccountsCardComponent,
    InvestmentInstructionSubmissionAffectedAccountListItemComponent,
    InvestmentInstructionSubmissionChangesCardComponent,
    InvestmentInstructionSubmissionInstructionChangesComponent,
    InvestmentInstructionSubmissionAllocationChangesComponent,
    MpProfileStaticInfoContainerComponent,
    ExistingSubmissionBannerComponent,
    MpProfileEmployerHistoryStaticInfoContainerComponent,
    SpouseInformationRadioButtonsComponent,
    SpousePersonalInformationFormComponent,
    SpouseContactDetailsFormComponent,
    RelationshipStatusFileUploadLabelPipe,
    RelationshipStatusFileUploadCopyPipe,
    RelationshipStatusSubmissionDetailGroupingComponent,
    SubmissionDetailsChangesComponent,
    SubmissionAffectedAccountDisplayNamePipe,
    DefinedContributionAccountsAccordionComponent,
    PaginatorComponent,
    AccountTypeSelectionFormComponent,
    MemberPersonalInformationOnboardingModalComponent,
    MemberOnboardingModalPersonalInformationFormComponent,
    MemberOnboardingModalContactInformationFormComponent,
    FiduciaryTypeNamePipe,
    DateIsInThePastPipe,
    EmploymentDetailsFormGridComponent,
    HeadOfficeAddressFormGridComponent,
    MailingAddressFormGridComponent,
    NoInvestedFundsBannerComponent,
    BatchAddMembersFileRequirementsComponent,
    BatchAddMembersFileUploadComponent,
    BatchAddMembersFilePreviewModalComponent,
    BatchAddMemberFilePreviewTableComponent,
    BatchAddMembersInformationTableCardComponent,
    MemberTableDateInputComponent,
    MemberTableEmailInputComponent,
    MemberTableSinInputComponent,
    MemberTableTextInputComponent,
    MemberTableTypeaheadDropdownComponent,
    FiduciarySubmissionSubmittedFileListComponent,
    ChipComponent,
    EmployerRecordPrimaryContactAccordionComponent,
    EmployerRecordAdditionalContactAccordionComponent,
    EmployerRecordContactRemoveModalComponent,
    EmployerRecordAddAdditionalContactModalComponent,
    EmployerRecordAddPrimaryContactModalComponent,
    EmployerContactSubmissionChangeCardComponent,
    EmployerContactSubmissionDetailsFieldChangeComponent,
    EmployerRecordContactsSectionComponent,
    EmployerContactCardComponent,
    SubmissionStatusLabelPipe,
    SubmissionStatusDatePipe,
    EmployerRecordPlanOverviewComponent,
    AccordionRemittanceItemComponent,
    RemittanceItemDetailsComponent,
    RemittanceItemHeaderComponent,
    RemittanceTransactionPreviewCardComponent,
    EmployerLogoHeaderComponent,
    VbWithdrawalInstructionsCardComponent,
    VbWithdrawalPercentFieldComponent,
    VbWithdrawalPercentageInputLabelComponent,
    FundTypeByIdPipe,
    VbConfigAccountDetailsReviewCardComponent,
    VbConfigMinAgeReviewCardComponent,
    VbConfigRecurringPaymentsReviewCardComponent,
    VbConfigLumpSumReviewCardComponent,
    VbConfigWithdrawalInstructionsReviewCardComponent,
    VbConfigDepositInstructionsReviewCardComponent,
    UpdateVbConfigAccountDetailsReviewCardComponent,
    UpdateVbConfigMinAgeReviewCardComponent,
    UpdateVbPaymentsMinAgeReviewCardComponent,
    UpdateVbPaymentsDepositInstructionsReviewCardComponent,
    UpdateVbPaymentsWithdrawalInstructionsReviewCardComponent,
    InvestmentInstructionAccountTypeContainerComponent,
    IsExhaustedAccountPipe,
    UpdateVbConfigRecurringPaymentsReviewCardComponent,
    UpdateVbConfigRecurringPaymentReviewCardComponent,
    UpdateVbConfigLumpSumReviewCardComponent,
    VbConfigSubmissionDetailsSpousalWaiverCardComponent,
    VbPaymentChangeAccordionComponent,
    VbPaymentsYearToDatePaymentsComponent,
    VbPaymentsAnnualMinimumComponent,
    VbPaymentsAnnualTotalComponent,
    VbPaymentsNextPaymentByComponent,
    VbPaymentChangeAgeForMinimumCalculationComponent,
    VbPaymentChangeAgeForMinimumCalculationJurisdictionComponent,
    VbPaymentChangeRecurringPaymentsComponent,
    VbPaymentChangeRecurringPaymentInstructionCardComponent,
    VbPaymentChangeWithdrawalInstructionsComponent,
    VbPaymentChangeUpcomingLumpSumPaymentsComponent,
    VbPaymentChangeDepositInstructionsComponent,
    VbPaymentChangeUpcomingPaymentsModalComponent,
    VariableBenefitAgeForMinimumCalculationNamePipe,
    CompactHeaderContainerComponent,
    VbRecurringPaymentsFrequencyFormGridComponent,
    VbJurisdictionRecurringPaymentCardComponent,
    VbJurisdictionLumpSumPaymentCardComponent,
    VbTargetPaymentComponent,
    VariableBenefitConfigurationReviewAccountValuesModalComponent,
    VariableBenefitConfigurationReviewAnnualMinimumModalComponent,
    VbCurrentRecurringPaymentsCardComponent,
    VariableBenefitPaymentChangeWarningBannerComponent,
    IpBeneficiarySubmissionSpousalWaiverComponent,
    MpBeneficiarySubmissionSpousalWaiverComponent,
  ],
  imports: [
    SubmissionContainerComponent,
    SubmissionStatusDateStringPipe,
    FormattedPhoneNumberPipe,
    IpAccountStatusMenuComponent,
    DataLabelComponent,
    MemberVerificationLabelItemComponent,
    MemberVerificationDetailsComponent,
    InternationalAddressFormGridComponent,
    UserProfileBadgeComponent,
    CommentComponent,
    SubmissionDetailsFieldChangesComponent,
    BeneficiaryDetailsIndividualChangesComponent,
    BeneficiaryDetailsOrganizationChangesComponent,
    BeneficiaryDetailsEstateChangesComponent,
    ThrottleClickDirective,
    BlackBackButtonComponent,
    StickyFooterComponent,
    GoverningJurisdictionNamePipe,
    VbConfigAssetsUsedReviewCardComponent,
    UpdateVbConfigAssetsUsedReviewCardComponent,
    SpousalWaiverTypeLabelPipe,
    SubmissionDetailsSpousalWaiverCardComponent,
    BannerAlertComponent,
    SystemBannerAlertComponent,
    ButtonToggleComponent,
    AccountAssetSelectionJurisdictionRowComponent,
    AccountAssetSelectionTypeRadioGroupComponent,
    AccountAssetSelectionUnlockFundsModalComponent,
    BaseActionModalComponent,
    MemberSearchComponent,
    MemberSearchInputComponent,
    MemberActiveStatusPillPipe,
    RemittanceStatusPillPipe,
    RemittancePaymentStatusPillPipe,
    AccountStatusPillPipe,
    CommonModule,
    MaterialModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    NgbTooltipModule,
    NgxPopperjsModule,
    LoadingComponent,
    LookAheadItemComponent,
    LookAheadListComponent,
    OdataTypeaheadSearchComponent,
    ReactiveFormModule,
    ReactiveButtonsModule,
    NgbCollapse,
    NgbDatepicker,
    RouterLink,
    LoadingShimmerModule,
    SlidingWindowCommentsComponent,
    CommentsFormComponent,
    CommentListComponent,
    InViewDirective,
    MaskitoDirective,
    NgbPopover,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownAnchor,
    NgbTypeahead,
    NgbAccordionBody,
    NgbAccordionCollapse,
    NgbAccordionDirective,
    NgbAccordionItem,
    ResizableModule,
    ButtonComponent,
    CloseButtonComponent,
    BaseCardComponent,
    StepperComponent,
    AccountDisplayNamePipe,
    FixedDecimalPipe,
    AccountTypeNamePipe,
    BaseLoadingButtonModalComponent,
    StatusPillComponent,
    CurrentEmployerPillComponent,
    IsCurrentEmploymentPipe,
    TabContentComponent,
    MonthlyPensionAccountContainerComponent,
    EntryFirstCurrencySymbolPipe,
    FormattedDateStringInCSTPipe,
    SlidingWindowComponent,
    SlidingWindowHeaderComponent,
    SlidingWindowFooterComponent,
    FakeCheckBoxComponent,
    FilterSectionHeaderComponent,
    SetHasPipe,
    CurrencySpacePipe,
    MaskSinNumberPipe,
    SinDisplayFieldComponent,
    TableCellShimmerComponent,
    TableResultsTextComponent,
    TableFilterPillsComponent,
    TableEmptyStateComponent,
    TableHeaderDateInputComponent,
    TableHeaderNumberInputComponent,
    TableHeaderDropdownInputComponent,
    TableHeaderTextInputComponent,
    TableColumnHeaderComponent,
    TablePaginatorComponent,
    TableFooterComponent,
    DndDirective,
    EllipsisPipe,
    PillComponent,
    CheckboxInputComponent,
    SwitchInputComponent,
    CurrencyInputComponent,
    DateInputComponent,
    DatepickerInputComponent,
    DatepickerInputCalendarComponent,
    DropdownInputComponent,
    EmailInputComponent,
    FileListItemComponent,
    AttachmentLinkPipe,
    LocalDateTimePipe,
    SubmissionPermissionTooltipPipe,
    FileUploadFieldComponent,
    FileUploadInputComponent,
    FileUploaderTextComponent,
    FormErrorComponent,
    FormOptionLabelComponent,
    MaskedTextInputComponent,
    NumericInputComponent,
    NumericStringInputComponent,
    PasswordInputComponent,
    PercentageInputComponent,
    PhoneCountryCodeComponent,
    PhoneCountryCodeDropdownInputComponent,
    PhoneCountryCodeNumberInputComponent,
    PillPickerInputComponent,
    RadioButtonInputComponent,
    RecurringCurrencyInputComponent,
    SearchPillInputComponent,
    SINInputComponent,
    TextInputComponent,
    TextareaInputComponent,
    TypeaheadDropdownInputComponent,
    TypeaheadSearchInputComponent,
    SearchInputComponent,
    TextButtonComponent,
    RepeatDirective,
    HeaderContainerComponent,
    BreadcrumbsComponent,
    DropdownButtonComponent,
    TabBarComponent,
    BreadcrumbHeaderComponent,
    LeadingZeroPipe,
    AgePipe,
    EmploymentStatusPillPipe,
    ReviewEntryComponent,
    RelationshipEffectiveDateReviewEntryComponent,
    SinReviewEntryComponent,
    RelationshipStatusEffectiveDateLabelPipe,
    BankAccountAccordionRadioCardComponent,
    PaylineAccountAccordionRadioCardComponent,
    WrittenChequeCardComponent,
    SpousalWaiverUploadCardComponent,
    AccountFileUploadComponent,
    ConfirmRelationshipStatusGridComponent,
    SubmissionSubmittedFileListComponent,
    SubmissionAdditionalFileListComponent,
    CurrencySpacePipe,
    VbAccountSummaryComponent,
  ],
  exports: [
    // Shared Components
    MaterialModule,
    LoadingComponent,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbsComponent,
    ThrottleClickDirective,
    LookAheadItemComponent,
    LookAheadListComponent,
    StaticInfoContainerComponent,
    DarkBackButtonComponent,
    BaseCardComponent,
    CloseButtonComponent,
    LogoComponent,
    TrustAsHtmlPipe,
    SlidingWindowComponent,
    SlidingWindowHeaderComponent,
    SlidingWindowFooterComponent,
    IconButtonComponent,
    VersionNumberExistsValidatorDirective,
    PillComponent,
    TableOverlayLoadingComponent,
    PageHeaderComponent,
    TabContentComponent,
    MonthlyPensionAccountContainerComponent,
    AddRemoveRoleFormComponent,
    FakeCheckBoxComponent,
    TableColumnSearchBarComponent,
    StatusPillComponent,
    CurrentEmployerPillComponent,
    IsCurrentEmploymentPipe,
    PendingSubmissionModalCardComponent,
    UserProfileBadgeComponent,
    DashboardHeaderComponent,
    ReorderModalComponent,
    DatePickerComponent,
    TableColumnDropDownBarComponent,
    OdataTypeaheadSearchComponent,
    ViewUserComponent,
    SubmissionPermissionCheckboxTableComponent,
    IndeterminateCheckboxComponent,
    MaskSinNumberPipe,
    DateValidDirective,
    CardAlertComponent,
    BannerAlertComponent,
    IsBannerTypeAlertPipe,
    IsCardTypeAlertPipe,
    StartEndDateValidatorDirective,
    NameChangeSubmissionFormComponent,
    GoverningJurisdictionNamePipe,
    SpousalWaiverTypeLabelPipe,
    AccountAssetSelectionJurisdictionRowComponent,
    AccountAssetSelectionTypeRadioGroupComponent,
    AccountAssetSelectionUnlockFundsModalComponent,
    AddressChangeSubmissionFormComponent,
    AddressSubmissionInProgressBannerComponent,
    UpdateContactInfoSubmissionFormComponent,
    HeaderContainerComponent,
    EntryFirstCurrencySymbolPipe,
    LabeledListItemComponent,
    HistoryItemComponent,
    DateStringWithAtPipe,
    EntryCodeNamePipe,
    PersonalInfoSubmissionFormComponent,
    BreadcrumbHeaderComponent,
    TableOverlayBufferComponent,
    DataLabelComponent,
    StepperComponent,
    FileUploaderTextComponent,
    SimplePillComponent,
    IncludesPipe,
    SetHasPipe,
    MapGetPipe,
    CurrencySpacePipe,
    StickyFooterComponent,
    MemberSearchComponent,
    MemberSearchInputComponent,
    TabBarComponent,
    PortalTypePipe,
    FormattedDateStringInCSTPipe,
    SlidingWindowCommentsComponent,
    SlidingWindowCommentsAndHistoryComponent,
    SlidingWindowCommentsTabComponent,
    SlidingWindowHistoryTabComponent,
    CommentsFormComponent,
    EmployerSearchInputComponent,
    DesignatedUnitSearchInputComponent,
    HumanReadablePipe,
    DataLabelPillComponent,
    LabeledListSinItemComponent,
    BlackBackButtonComponent,
    AlertComponent,
    SystemBannerAlertComponent,
    SubmissionContainerComponent,
    DonutChartComponent,
    DonutChartWithLegendComponent,
    MobileNumericInputComponent,
    CurrencyInputComponent,
    RecurringCurrencyInputComponent,
    PercentageInputComponent,
    ActionCardComponent,
    InvestmentInstructionsCardComponent,
    CheckboxInputComponent,
    SwitchInputComponent,
    FormOptionLabelComponent,
    AffectedAccountsCardComponent,
    JoinPipe,
    InvestmentInstructionFundColourPipe,
    RepeatDirective,
    DonutChartLegendComponent,
    ButtonToggleComponent,
    TabToggleComponent,
    DesignatedUnitsTableCardComponent,
    CreateDesignatedUnitGeneralDetailsAboutSectionComponent,
    CreateDesignatedUnitGeneralDetailsEffectivePeriodSectionComponent,
    CreateDesignatedUnitRequiredContributionsFormComponent,
    CreateDesignatedUnitEmployeeParticipationFormComponent,
    RadioButtonInputComponent,
    PrimaryCreateSubmissionButtonComponent,
    ChangeInvestmentInstructionsSubmissionFormComponent,
    AccountInvestmentInstructionsCardComponent,
    FileUploadInputComponent,
    FileListItemComponent,
    AttachmentLinkPipe,
    LocalDateTimePipe,
    SubmissionPermissionTooltipPipe,
    FileUploadFieldComponent,
    InternalPortalAffectedAccountsCardComponent,
    SearchInputComponent,
    NumericInputComponent,
    NumericStringInputComponent,
    PillPickerInputComponent,
    PreviousInstructionsSubmissionVisualizationComponent,
    FutureInstructionsVisualizationComponent,
    CurrentInstructionsVisualizationComponent,
    FundAllocationVisualizationComponent,
    CommentComponent,
    InvestmentInstructionSubmissionAffectedAccountsCardComponent,
    InvestmentInstructionSubmissionAffectedAccountListItemComponent,
    InvestmentInstructionSubmissionChangesCardComponent,
    InvestmentInstructionSubmissionInstructionChangesComponent,
    InvestmentInstructionSubmissionAllocationChangesComponent,
    FilterSectionHeaderComponent,
    FixedDecimalPipe,
    DropdownInputComponent,
    SINInputComponent,
    EmailInputComponent,
    PhoneCountryCodeComponent,
    ButtonComponent,
    TextareaInputComponent,
    MpProfileStaticInfoContainerComponent,
    DropdownButtonComponent,
    DatepickerInputComponent,
    MpProfileEmployerHistoryStaticInfoContainerComponent,
    SpouseInformationRadioButtonsComponent,
    TextInputComponent,
    SpousePersonalInformationFormComponent,
    SpouseContactDetailsFormComponent,
    RelationshipStatusEffectiveDateLabelPipe,
    RelationshipStatusFileUploadLabelPipe,
    FormErrorComponent,
    BaseLoadingButtonModalComponent,
    ExistingSubmissionBannerComponent,
    RelationshipStatusFileUploadCopyPipe,
    RelationshipStatusSubmissionDetailGroupingComponent,
    SubmissionDetailsChangesComponent,
    SubmissionSubmittedFileListComponent,
    SubmissionAdditionalFileListComponent,
    DateInputComponent,
    TypeaheadDropdownInputComponent,
    TypeaheadSearchInputComponent,
    ReviewEntryComponent,
    SinReviewEntryComponent,
    RelationshipEffectiveDateReviewEntryComponent,
    AccountTypeNamePipe,
    AccountDisplayNamePipe,
    SubmissionAffectedAccountDisplayNamePipe,
    DefinedContributionAccountsAccordionComponent,
    RelationshipEffectiveDateReviewEntryComponent,
    PaginatorComponent,
    SubmissionDetailsFieldChangesComponent,
    BeneficiaryDetailsIndividualChangesComponent,
    BeneficiaryDetailsOrganizationChangesComponent,
    BeneficiaryDetailsEstateChangesComponent,
    AccountTypeSelectionFormComponent,
    TextButtonComponent,
    MaskedTextInputComponent,
    FiduciaryTypeNamePipe,
    FormattedPhoneNumberPipe,
    DateIsInThePastPipe,
    MemberVerificationDetailsComponent,
    MemberVerificationLabelItemComponent,
    EmploymentDetailsFormGridComponent,
    InternationalAddressFormGridComponent,
    HeadOfficeAddressFormGridComponent,
    MailingAddressFormGridComponent,
    NoInvestedFundsBannerComponent,
    TableColumnHeaderComponent,
    TableFooterComponent,
    TableFilterPillsComponent,
    TableEmptyStateComponent,
    SearchPillInputComponent,
    BatchAddMembersFileRequirementsComponent,
    BatchAddMembersFileUploadComponent,
    SinDisplayFieldComponent,
    BatchAddMembersInformationTableCardComponent,
    FiduciarySubmissionSubmittedFileListComponent,
    ChipComponent,
    SubmissionStatusDateStringPipe,
    SubmissionStatusDatePipe,
    EmployerRecordPrimaryContactAccordionComponent,
    EmployerRecordContactRemoveModalComponent,
    TableCellShimmerComponent,
    EmployerRecordAdditionalContactAccordionComponent,
    MemberActiveStatusPillPipe,
    RemittanceStatusPillPipe,
    RemittancePaymentStatusPillPipe,
    EmployerContactSubmissionChangeCardComponent,
    EmployerContactSubmissionDetailsFieldChangeComponent,
    EmployerRecordContactsSectionComponent,
    SubmissionStatusLabelPipe,
    MaskitoDirective,
    EmployerRecordPlanOverviewComponent,
    AccordionRemittanceItemComponent,
    RemittanceItemDetailsComponent,
    RemittanceItemHeaderComponent,
    RemittanceTransactionPreviewCardComponent,
    EmployerLogoHeaderComponent,
    ConfirmRelationshipStatusGridComponent,
    AgePipe,
    FundTypeByIdPipe,
    VbWithdrawalInstructionsCardComponent,
    WrittenChequeCardComponent,
    BankAccountAccordionRadioCardComponent,
    PaylineAccountAccordionRadioCardComponent,
    VbConfigAccountDetailsReviewCardComponent,
    VbConfigAssetsUsedReviewCardComponent,
    VbConfigMinAgeReviewCardComponent,
    VbConfigRecurringPaymentsReviewCardComponent,
    VbConfigLumpSumReviewCardComponent,
    VbConfigWithdrawalInstructionsReviewCardComponent,
    VbConfigDepositInstructionsReviewCardComponent,
    UpdateVbConfigAccountDetailsReviewCardComponent,
    UpdateVbConfigAssetsUsedReviewCardComponent,
    UpdateVbConfigMinAgeReviewCardComponent,
    UpdateVbPaymentsMinAgeReviewCardComponent,
    UpdateVbPaymentsDepositInstructionsReviewCardComponent,
    UpdateVbPaymentsWithdrawalInstructionsReviewCardComponent,
    SpousalWaiverUploadCardComponent,
    AccountFileUploadComponent,
    VbAccountSummaryComponent,
    PasswordInputComponent,
    IsExhaustedAccountPipe,
    VbConfigSubmissionDetailsSpousalWaiverCardComponent,
    SubmissionDetailsSpousalWaiverCardComponent,
    UpdateVbConfigRecurringPaymentsReviewCardComponent,
    UpdateVbConfigLumpSumReviewCardComponent,
    VbPaymentChangeAccordionComponent,
    VbPaymentsAnnualMinimumComponent,
    VbPaymentsAnnualTotalComponent,
    VbPaymentsNextPaymentByComponent,
    VbPaymentsYearToDatePaymentsComponent,
    VbPaymentChangeAgeForMinimumCalculationComponent,
    VbPaymentChangeRecurringPaymentsComponent,
    VbPaymentChangeUpcomingLumpSumPaymentsComponent,
    VbPaymentChangeWithdrawalInstructionsComponent,
    VbPaymentChangeDepositInstructionsComponent,
    VariableBenefitAgeForMinimumCalculationNamePipe,
    CompactHeaderContainerComponent,
    VbRecurringPaymentsFrequencyFormGridComponent,
    VbJurisdictionRecurringPaymentCardComponent,
    VbJurisdictionLumpSumPaymentCardComponent,
    VbTargetPaymentComponent,
    VariableBenefitConfigurationReviewAccountValuesModalComponent,
    VariableBenefitConfigurationReviewAnnualMinimumModalComponent,
    VbCurrentRecurringPaymentsCardComponent,
    VariableBenefitPaymentChangeWarningBannerComponent,
    AccountStatusPillPipe,
    IpBeneficiarySubmissionSpousalWaiverComponent,
    MpBeneficiarySubmissionSpousalWaiverComponent,
    LeadingZeroPipe,
  ],
})
export class SharedModule {}
